import styled, { css } from 'styled-components'

import {
  _2XL_Bold,
  _2XS_Normal,
  _L_Bold,
  _L_Medium,
  _M_Bold,
  _M_Light,
  _M_Medium,
  _M_Normal,
  _S_Bold,
  _S_Medium,
  _S_Normal,
  _XL_Bold,
  _XL_Light,
  _XL_Medium,
  _XS_Bold,
  _XS_Light,
  _XS_Medium,
  _XS_Normal,
} from '../../styles'

interface ParagraphProps {
  color?: string
  textAlign?: string
}

const commonStyles = css<ParagraphProps>`
  color: ${({ color }) => color};
  ${({ textAlign }) => textAlign && `text-align: ${textAlign}`};
`

export const XXSNormal = styled.p<ParagraphProps>`
  ${_2XS_Normal};
  ${commonStyles};
`

export const XSBold = styled.p<ParagraphProps>`
  ${_XS_Bold};
  ${commonStyles};
`

export const XSMedium = styled.p<ParagraphProps>`
  ${_XS_Medium};
  ${commonStyles};
`

export const XSLight = styled.p<ParagraphProps>`
  ${_XS_Light};
  ${commonStyles};
`

export const XSNormal = styled.p<ParagraphProps>`
  ${_XS_Normal};
  ${commonStyles};
`

export const LMedium = styled.p<ParagraphProps>`
  ${_L_Medium};
  ${commonStyles};
`

export const MBold = styled.p<ParagraphProps>`
  ${_M_Bold};
  ${commonStyles};
`

export const MMedium = styled.p<ParagraphProps>`
  ${_M_Medium};
  ${commonStyles};
`

export const MNormal = styled.p<ParagraphProps>`
  ${_M_Normal};
  ${commonStyles};
`

export const MLight = styled.p<ParagraphProps>`
  ${_M_Light};
  ${commonStyles};
`

export const SBold = styled.p<ParagraphProps>`
  ${_S_Bold};
  ${commonStyles};
`

export const SNormal = styled.p<ParagraphProps>`
  ${_S_Normal};
  ${commonStyles};
`

export const SMedium = styled.p<ParagraphProps>`
  ${_S_Medium};
  ${commonStyles};
`

export const LBold = styled.p<ParagraphProps>`
  ${_L_Bold};
  ${commonStyles};
`

export const XLMedium = styled.p<ParagraphProps>`
  ${_XL_Medium};
  ${commonStyles};
`

export const XLBold = styled.p<ParagraphProps>`
  ${_XL_Bold};
  ${commonStyles};
`

export const XLLight = styled.p<ParagraphProps>`
  ${_XL_Light};
  ${commonStyles};
`

export const XXLBold = styled.p<ParagraphProps>`
  ${_2XL_Bold};
  ${commonStyles};
`
